import { Injectable } from "@angular/core";
import {
  Http,
  Headers,
  RequestOptions,
  ResponseContentType,
  RequestOptionsArgs
} from "@angular/http";
import { ApiConnectService } from "./api-connect.service";
import { Report } from "../models/report.model";
import { FullUser } from "../models/full-user.model";
import { Group } from "../models/group.model";
import { CreatingStandard } from "../models/creating-standard.model";
import { Standard } from "../models/standard.model";
import { NewBlank } from "../models/new-blank.model";
import { MultiQuestions } from "../models/multi-questions";
import { DisseminationModel } from "../models/dissemination.model";
import { Blank } from "../models/blank.model";
import { Question } from "../models/question.model";
import { Status } from "../models/status.model";
import { HttpClient, HttpHeaders, HttpParams, HttpResponse } from "@angular/common/http";
import { UserService } from "./user.service";
import { Observable } from "rxjs";

// import {cyrillicToTranslit} from '../../../node_modules/cyrillic-to-translit-js';

// const cyrillicToTranslit = require('cyrillic-to-translit-js');
// import {cyrillicToTranslit} from 'cyrillic-to-translit-js';
// import {cyrillicToTranslit} from '../../../node_modules/cyrillic-to-translit-js/CyrillicToTranslit.d';

@Injectable()
export class AdminService {
  // *** Here all the functionality of the administrator ***;
  constructor(
    private http: HttpClient,
    private userService: UserService,
    private apiURL: ApiConnectService
  ) {}

  getTempDocxFileLink(fid, sid) {
    const header = new HttpHeaders({
      fid: fid,
      sid: sid
    });

    return this.http.get(this.apiURL.getTempFileLink, {
      headers: header,
      responseType: "text",
      observe: "response"
    });
  }

  deleteTempDocxFileLink(fid) {
    const header = new HttpHeaders({
      fid: fid
    });

    return this.http.delete(this.apiURL.deleteTempFileLink, {
      headers: header,
      observe: "response"
    });
  }

  getMyGroups(id: string) {
    return this.http.get(this.apiURL.getMyGroups + id + '/groups/', {observe: 'response'});
  }

  // Create schedules
  createSchedule(schedule) {
    return this.http.post(this.apiURL.createScheduleHead, schedule, {
      observe: "response"
    });
  }

  // Create position
  createPosition(position, groudID) {
    return this.http.post(
      this.apiURL.createPosition + groudID + "/position",
      position,
      { observe: "response" }
    );
  }

  // Create position (global)
  createPositionGlobal(position) {
    // const newPos = {
    //   "name": position
    // };
    // return this.http.post(this.apiURL.createPosition + groudID + '/position', position, {observe: 'response'});
    return this.http.post(this.apiURL.createPositionGlobal, position, {
      observe: "response"
    });
  }

  setPositionStatus(posId, posStatus) {
    return this.http.patch(
      this.apiURL.changePositionStatus + posId + "/active/" + posStatus,
      null,
      {
        observe: "response"
      }
    );
  }

  // Create fullUser
  createFullUser(user, group, position) {
    // send 3 in 1
    const createUserAllObjects = {
      user,
      group,
      position
    };

    return this.http.post(this.apiURL.createUser, createUserAllObjects, {
      observe: "response"
    });
  }

  // Create group OLD
  // createGroup(group) {
  //   return this.http.post(this.apiURL.createGroup, group, {observe: 'response'});
  // }

  createGroup(group) {
    return this.http.post(this.apiURL.createGroup, group, {
      observe: "response"
    });
  }

  sendFile(file) {
    return this.http.post(this.apiURL.addFileToStandard, file, {
      observe: "response"
    });
  }

  /*
   GETTERS GET
   */
   getLastVector(id) {
    return this.http.get(this.apiURL.lastVector + id, { observe: "response" });
  }

  // getListVectors(groupId, vectorOrders) {
  //   let params = new HttpParams();
  //   vectorOrders.forEach(order => {
  //       params = params.append('vectorOrders', order);
  //   });

  //   return this.http.get(`backend/common/group/${groupId}/users/vector`, { observe: "response", params: params });
  // }

  getListVectors(groupId: string, data: any): Observable<any> {
    const url = `backend/common/group/${groupId}/users/vector`;
    return this.http.post(url, data, { observe: "response" });
  }

  getListVectorsNoSalary(groupId: string, data: any): Observable<any> {
    const url = `backend/common/group/${groupId}/users/without_salary/vector`;
    return this.http.post(url, data, { observe: "response" });
  }

  getListLastVector() {
    return this.http.get(this.apiURL.lastVectorListUsers, { observe: "response" });
  }

  getFullVector(id, from, to) {
    return this.http.get(this.apiURL.fullVector + id + '?' + new HttpParams().set('from', String(from)).set('to', String(to)), { observe: "response" });
  }

  getUsersShift(id) {
    return this.http.post(this.apiURL.getShift + id, { observe: "response" });
  }

  getsUsersShift() {
    return this.http.get(this.apiURL.getShiftget, { observe: "response" });
  }

  pullShift(param) {
    return this.http.post(this.apiURL.pullShift, param, { observe: "response" });
  }

  getFullVectorAll(from, to) {
    return this.http.get(this.apiURL.fullVectorAll + '?' + new HttpParams().set('from', String(from)).set('to', String(to)), { observe: "response" });
  }

  getAllFullUsers() {
    return this.http.get(this.apiURL.getAllUsers, { observe: "response" });
  }

  getSchedules() {
    return this.http.get(this.apiURL.getAllSchedules, { observe: "response" });
  }

  postiruem(id, tumbler) {
    return this.http.post(this.apiURL.postiruem + id + '?' + new HttpParams().set("tumbler", tumbler), { observe: "response" });
  }

  postiruemOver(id, tumbler) {
    return this.http.post(this.apiURL.postiruemOver + id + '?' + new HttpParams().set("tumbler", tumbler), { observe: "response" });
  }

  outsorce(id, tumbler) {
    return this.http.post(this.apiURL.outsorce + id + '?' + new HttpParams().set("tumbler", tumbler), { observe: "response" });
  }

  getAllGroups() {
    return this.http.get(this.apiURL.getAllGroups, { observe: "response" });
  }

  getAllGroupsForList() {
    return this.http.get(this.apiURL.getAllGroupsForStandartList, { observe: "response" });
  }

  getAllGroupsForListMap(id) {
    return this.http.get(this.apiURL.getAllGroupsForStandartListMap + id, { observe: "response" });
  }

  getAllGroupsAll() {
    return this.http.get(this.apiURL.getAllGroupsHeadAll, { observe: "response" });
  }


  getAllGroupsHead() {
    return this.http.get(this.apiURL.getAllGroupsHead, { observe: "response" });
  }

  getAllGroupsHeadPlanfix() {
    return this.http.get(this.apiURL.getAllGroupsHeadPlanfix, {
      observe: "response"
    });
  }

  getDepartmentGroups() {
    return this.http.get(this.apiURL.getDepartmentGroups, {
      observe: "response"
    });
  }

  getAffiliateGroups() {
    return this.http.get(this.apiURL.getAffiliateGroups, {
      observe: "response"
    });
  }

  getGlobalGroups() {
    return this.http.get(this.apiURL.getGlobalGroups, { observe: "response" });
  }

  getAllPositions() {
    // GET POSITIONS FROM GROUP
    return this.http.get(this.apiURL.getAllPositions, {
      observe: "response"
    });
  }

  getActivePositions() {
    const params = new HttpParams().set("active", "true");
    return this.http.get(this.apiURL.getAllPositions, {
      observe: "response",
      params: params
    });
  }

  getGroupByID(groupID) {
    return this.http.get(this.apiURL.getGroupById + groupID, {
      observe: "response"
    });
  }

  deleteEvent(groupID) {
    return this.http.delete(this.apiURL.deleteEvent + groupID, {
      observe: "response"
    });
  }

  checkLevel(id) {
    return this.http.get(this.apiURL.checkLevel + id, {observe: 'response'});
  }

  pushTask(id) {
    return this.http.post(this.apiURL.pushTask + id, null);
  }

  // GET ALL STANDARDS
  getAllStandards() {
    let page: string;
    if (localStorage.getItem("lastPage")) {
      page = (Number(localStorage.getItem("lastPage")) - 1).toString();
    } else {
      page = "0";
    }
    const parameters = {
      page: page,
      sort: "number,asc",
      size: "15",
      value: ""
    };

    const params = new HttpParams()
      .set("page", parameters.page)
      .set("sort", parameters.sort)
      .set("size", parameters.size)
      .set("value", parameters.value);

    return this.http.get(this.apiURL.getAllStandards, {
      observe: "response",
      params: params
    });
  }

  getAllStandardsById(id) {
    let page: string;
    if (localStorage.getItem("lastPage")) {
      page = (Number(localStorage.getItem("lastPage")) - 1).toString();
    } else {
      page = "0";
    }
    const parameters = {
      page: page,
      sort: "number,asc",
      size: "15",
      value: ""
    };

    const params = new HttpParams()
      .set("page", parameters.page)
      .set("sort", parameters.sort)
      .set("size", parameters.size)
      .set("value", parameters.value);

    return this.http.get(this.apiURL.getAllStandardsId + id, {
      observe: "response",
      params: params
    });
  }

  getPageServera(id, page, searchValue, status, sortId) {
    const parameters = {
      page: page,
      sort: sortId,
      size: "15",
      status: status,
      value: searchValue
    };

    let params = new HttpParams()
      .set("page", parameters.page)
      .set("sort", parameters.sort)
      .set("size", parameters.size)
      .set("value", searchValue);

    if (status !== "") {
      params = params.set("status", parameters.status);
    }

  return this.http.get(this.apiURL.getAllStandardsId + id, {
    observe: "response",
    params: params
  });
}

  // GET ALL STANDARDS
  getAllStandardsGroup() {
    return this.http.get(this.apiURL.getAllStandards, { observe: "response" });
  }

  // getAllStandardsWithoutSort
  getAllStandardsGroupWithoutSort() {
    return this.http.get(this.apiURL.getAllStandardsWithoutSort, {
      observe: "response"
    });
  }

  // STANDARD SEARCH
  getAllStandardsByValue(searchValue) {
    const parameters = {
      page: "0",
      sort: "number,asc",
      size: "15",
      value: searchValue
    };

    const params = new HttpParams()
      .set("page", parameters.page)
      .set("sort", parameters.sort)
      .set("size", parameters.size)
      .set("value", searchValue);

    return this.http.get(this.apiURL.getAllStandards, {
      observe: "response",
      params: params
    });
  }

  // GET FILTERED STANDARDS
  getFilteredStandards(searchValue, status) {
    const parameters = {
      page: "0",
      sort: "number,asc",
      size: "15",
      status: status,
      value: searchValue
    };

    let params = new HttpParams()
      .set("page", parameters.page)
      .set("sort", parameters.sort)
      .set("size", parameters.size)
      .set("value", parameters.value);

    if (status !== "") {
      params = params.set("status", parameters.status);
    }

    return this.http.get(this.apiURL.getAllStandards, {
      observe: "response",
      params: params
    });
  }

  // GET SORTED STANDARDS
  getSortedStandards(currentPage, sortId, searchValue, status) {
    const parameters = {
      page: currentPage,
      sort: sortId,
      size: "15",
      status: status,
      value: searchValue
    };

    let params = new HttpParams()
      .set("page", parameters.page)
      .set("sort", parameters.sort)
      .set("size", parameters.size)
      .set("value", parameters.value);

    if (status !== "") {
      params = params.set("status", parameters.status);
    }

    return this.http.get(this.apiURL.getAllStandards, {
      observe: "response",
      params: params
    });
  }

  // GET DATA FROM PAGE
  getPageServer(page, searchValue, status, sortId) {
    const parameters = {
      page: page,
      sort: sortId,
      size: "15",
      status: status,
      value: searchValue
    };

    let params = new HttpParams()
      .set("page", parameters.page)
      .set("sort", parameters.sort)
      .set("size", parameters.size)
      .set("value", searchValue);

    if (status !== "") {
      params = params.set("status", parameters.status);
    }

    return this.http.get(this.apiURL.getAllStandards, {
      observe: "response",
      params: params
    });
  }

  getUserOutSide(groupID) {
    return this.http.get(this.apiURL.getUsersOutsideOfGroup + groupID, {
      observe: "response"
    });
  }

  putUserOfGroup(groupID, userID, positionID) {
    return this.http.patch(
      this.apiURL.putUserOfGroup +
        groupID +
        "/adduser/" +
        userID +
        "/" +
        positionID,
      null,
      { observe: "response" }
    );
  }

  setHeadsForGroup(groupID, headID, deputyID) {
    return this.http.patch(
      this.apiURL.setHeadsForGroup +
        groupID +
        "/setheads/" +
        headID +
        "/" +
        deputyID,
      null,
      { observe: "response" }
    );
  }

  changeKarma(group) {
    return this.http.patch(this.apiURL.changeKarmaUser, group, {
      observe: "response"
    });
  }

  changeEmploy(id, group) {
    return this.http.post(`/backend/common/head/user/${id}/date_of_employment` + '?' + new HttpParams().set("dateOfEmployment", group), {
      observe: "response"
    });
  }


  changeVector(id, valueOne, valueTwo, valueThree, valueFour, valueFive) {
    let stringVector = valueOne + ',' + valueTwo + ',' + valueThree + ',' + valueFour + ',' + valueFive;
    return this.http.post(this.apiURL.changeVector + '?' + new HttpParams().set("userID", id).set("components", stringVector),  {
      observe: "response"
    });
  }


  changeUserStatusInGroup(groupID, userID, status: string) {
    const header = new HttpHeaders({
      "current-status": status
    });

    return this.http.patch(
      this.apiURL.changeUserStatusInGroup + groupID + "/" + userID + "/status",
      null,
      {
        headers: header,
        observe: "response"
      }
    );
  }

  updateUser(user: FullUser | any) {
    return this.http.patch(this.apiURL.updateUser, user, {
      observe: "response"
    });
  }

  getKarmaInfo(userId, from, to) {
    return this.http.get(this.apiURL.getKarmaInfo + '?' + new HttpParams().set('userId', userId).set('from', from).set('to', to), {
      observe: "response",
    });
  }

  getChtoto(id) {
    return this.http.get(this.apiURL.getChtoto + id, {
      observe: "response",
    });
  }

  getWorkDays(userId, from, to) {
    return this.http.get<HttpResponse<any>>(`/backend/common/user/${userId}/working_dey` + '?' + new HttpParams().set('from', from).set('to', to), {
      observe: 'response'
    });
  }

  getExcelReport(reports: Report[], groupName: string) {
    return this.http.put(
      this.apiURL.getExcelReport + "?group_name=" + groupName,
      reports,
      {
        responseType: "blob",
        observe: "response"
      }
    );
  }

  updateGroup(group) {
    return this.http.patch(this.apiURL.updateGroup, group, {
      observe: "response"
    });
  }

  convertGroup(group, type) {
    return this.http.patch(this.apiURL.convertGroup + type, group, {
      observe: "response"
    });
  }

  addRelative(group) {
    return this.http.patch(this.apiURL.addRelative, group, {
      observe: "response"
    });
  }

  /*
   UPDATERS PATCH
   */

  getStandard(standardId) {
    const reqHeaders = new HttpHeaders({
      offset: this.userService.getTimezoneOffset()
    });
    return this.http.get(this.apiURL.getStandard + standardId, {
      observe: "response",
      headers: reqHeaders
    });
  }

  getStandardTemp(standardId) {
    return this.http.get(this.apiURL.getStandard + standardId + "/tmp", {
      observe: "response"
    });
  }

  getTempStandard(standardId) {
    return this.http.get(this.apiURL.getTempStandard + standardId + "/tmp", {
      observe: "response"
    });
  }

  createStandard(standard: CreatingStandard, applyOnlyHeads) {
    return this.http.post(this.apiURL.createStandard  + '?' + new HttpParams().set('applyOnlyHeads', applyOnlyHeads) , standard, {
      observe: "response"
    });
  }

  createStandardd(standard: CreatingStandard) {
    return this.http.post(this.apiURL.createStandard + '?' + new HttpParams().set('applyOnlyHeads', 'false'), standard, {
      observe: "response"
    });
  }

  notifyIsView(param) {
    return this.http.patch(this.apiURL.markNotify, param, {
      observe: "response"
    });
  }

  notifyIsViewNot(param) {
    return this.http.patch(this.apiURL.markNotifyNot, param, {
      observe: "response"
    });
  }


  addQuestionsToStandard(questions: MultiQuestions, id: string) {
    const headers = new HttpHeaders({
      id: id
    });
    return this.http.post(this.apiURL.addQuestionToStandardById, questions, {
      headers: headers,
      observe: "response"
    });
  }

  editQuestionInStandard(
    combinedQuestions: any,
    sid: string,
    questionLang: string
  ) {
    const params = new HttpParams().set("sid", sid).set("lang", questionLang);
    return this.http.post(
      this.apiURL.editQuestionInStandard,
      combinedQuestions,
      {
        params,
        observe: "response"
      }
    );
  }

  setTempQuestionsForStandard(sID, questionsBody) {
    return this.http.patch(
      this.apiURL.setTempQuestionsForStandard + sID + "/questions",
      questionsBody,
      { observe: "response" }
    );
  }

  rusToLatin(str) {
    const ru = {
        а: "a",
        б: "b",
        в: "v",
        г: "g",
        д: "d",
        е: "e",
        ё: "e",
        ж: "j",
        з: "z",
        и: "i",
        к: "k",
        л: "l",
        м: "m",
        н: "n",
        о: "o",
        п: "p",
        р: "r",
        с: "s",
        т: "t",
        у: "u",
        ф: "f",
        х: "h",
        ц: "c",
        ч: "ch",
        ш: "sh",
        щ: "shch",
        ы: "y",
        э: "e",
        ю: "u",
        я: "ya"
      },
      n_str = [];

    str = str.replace(/[ъь]+/g, "").replace(/й/g, "i");

    for (let i = 0; i < str.length; ++i) {
      n_str.push(
        ru[str[i]] ||
          (ru[str[i].toLowerCase()] === undefined && str[i]) ||
          ru[str[i].toLowerCase()].replace(/^(.)/, function(match) {
            return match.toUpperCase();
          })
      );
    }

    return n_str.join("");
  }

  uploadFiles(standard, formData: FormData) {
    // .doc      application/msword
    // .docx     application/vnd.openxmlformats-officedocument.wordprocessingml.document
    // .ppt      application/vnd.ms-powerpoint
    // .pptx     application/vnd.openxmlformats-officedocument.presentationml.presentation

    const headers = new HttpHeaders({
      id: standard.id
    });

    headers.append("Content-Type", "multipart/form-data");

    return this.http.post(this.apiURL.uploadFile, formData, {
      headers: headers,
      observe: "response"
    });
  }

  uploadFilesTemp(standardID, formData) {
    const headers = new HttpHeaders({
      id: standardID
    });
    return this.http.post(this.apiURL.uploadFileTemp, formData, {
      headers: headers,
      observe: "response"
    });
  }

  uploadBlank(standard, blanks: NewBlank[]) {
    const headers = new HttpHeaders({
      id: standard.id
    });

    const formData: FormData = new FormData();

    for (const blank of blanks) {
      formData.append("name", blank.name);
      formData.append("number", blank.number);
      formData.append("file", blank.formData.get("file"));
    }

    return this.http.post(this.apiURL.uploadBlank, formData, {
      headers: headers,
      observe: "response"
    });
  }

  uploadBlankTemp(standardID, blanks: NewBlank[]) {
    const headers = new HttpHeaders({
      id: standardID
    });

    const formData: FormData = new FormData();
    for (const blank of blanks) {
      formData.append("name", blank.name);
      formData.append("number", blank.number);
      formData.append("file", blank.formData.get("file"));
    }
    return this.http.post(this.apiURL.uploadBlankTemp, formData, {
      headers: headers,
      observe: "response"
    });
  }

  disseminateStandard(dissemination, standardID) {
    return this.http.patch(
      this.apiURL.disseminateStandardNew + standardID + "/distribute",
      dissemination,
      { observe: "response" }
    );
  }

  deleteBlankFromStandard(blank, standard) {
    const headers = new HttpHeaders({
      sid: standard.id,
      bid: blank.fileId
    });
    return this.http.delete(this.apiURL.deleteBlankFromStandard, {
      headers: headers,
      observe: "response"
    });
  }

  deleteBlankFromStandardTemp(blank, standardID) {
    const headers = new HttpHeaders({
      sid: standardID,
      bid: blank.fileId
    });
    return this.http.delete(this.apiURL.deleteBlankFromStandardTemp, {
      headers: headers,
      observe: "response"
    });
  }

  deleteQuestionFromStandard(
    standard: Standard,
    question: Question,
    lang: string
  ) {
    const headers = new HttpHeaders({
      sid: standard.id,
      lang: lang
    });

    return this.http.patch(this.apiURL.deleteQuestion, question, {
      headers,
      observe: "response"
    });
  }

  deleteFileFromStandard(fileId: string, type: string, standard: any) {
    const headers = new HttpHeaders({
      sid: standard.id,
      fid: fileId,
      type: type
    });
    return this.http.delete(this.apiURL.deleteFileFromStandard, {
      headers: headers,
      observe: "response"
    });
  }

  deleteFileFromStandardTemp(fileId: string, type: string, standardID) {
    const headers = new HttpHeaders({
      sid: standardID,
      fid: fileId,
      type: type
    });
    return this.http.delete(this.apiURL.deleteFileFromStandardTemp, {
      headers: headers,
      observe: "response"
    });
  }

  changeStatus(standard, selectedStatus) {
    const headers = new HttpHeaders({
      sid: standard.id,
      status: selectedStatus
    });
    return this.http.patch(this.apiURL.changeStandardStatus, null, {
      headers: headers
    });
  }

  changeStatusToActive(standardId, selectedStatus) {
    const headers = new HttpHeaders({
      sid: standardId,
      status: selectedStatus
    });
    return this.http.patch(this.apiURL.changeStandardStatus, null, {
      headers: headers,
      observe: "response"
    });
  }

  changeStatusHead(standardID, selectedStatus) {
    const headers = new HttpHeaders({
      sid: standardID,
      status: selectedStatus
    });
    return this.http.patch(this.apiURL.changeStandardStatusHead, null, {
      headers: headers
    });
  }

  changeInitiator(standard: Standard, selectedUser: FullUser) {
    const headers = new HttpHeaders({
      sid: standard.id,
      uid: selectedUser.id
    });
    return this.http.patch(this.apiURL.changeInitiator, null, {
      headers: headers,
      observe: "response"
    });
  }

  changeDivision(standard: Standard, selectedDivision: Group) {
    return this.http.put(
      this.apiURL.changeDivision +
        standard.id +
        "/group/" +
        selectedDivision.id,
      null,
      { observe: "response" }
    );
  }

  editStandardInfo(standard: Standard, info: any) {
    const headers = new HttpHeaders({
      sid: standard.id
    });
    return this.http.patch(this.apiURL.editStandardInfo, info, {
      headers: headers,
      observe: "response"
    });
  }

  addQuestionToStandard(standard: Standard, multiQuestion: MultiQuestions) {
    const headers = new HttpHeaders({
      sid: standard.id
    });

    return this.http.put(this.apiURL.addQuestionToStandard, multiQuestion, {
      headers: headers,
      observe: "response"
    });
  }

  changeUserPositionInGroup(gid, uid, pid) {
    const headers = new HttpHeaders({
      pid: pid
    });
    return this.http.patch(
      this.apiURL.changeUserPositionInGroup + gid + "/" + uid + "/position",
      null,
      {
        headers: headers,
        observe: "response"
      }
    );
  }

  changeUserPassword(uid, newPass) {
    const headers = new HttpHeaders({
      uid: uid
    });
    return this.http.post(this.apiURL.changeUserPassword, newPass, {
      headers: headers,
      observe: "response"
    });
  }

  changePositionNameInGroup(gid, pid, newName) {
    const headers = new HttpHeaders({
      gid: gid,
      pid: pid
    });
    return this.http.patch(this.apiURL.changePositionNameInGroup, newName, {
      headers: headers,
      observe: "response"
    });
  }

  deletePositionFromGroup(gid, pid) {
    const headers = new HttpHeaders({
      gid: gid,
      pid: pid
    });
    return this.http.delete(this.apiURL.deletePositionFromGroup, {
      headers: headers,
      observe: "response"
    });
  }

  // GET Получить пользователей, на которых не распространяется действие стандарта
  getUsersOusideStandard(standardID) {
    return this.http.get(
      this.apiURL.getStandardOutsidesUsers + standardID + "/out",
      { observe: "response" }
    );
  }

  addUserToStandard(id, id2) {
    // PUT Добавить пользователя к действующему стандарту
    return this.http.put(
      this.apiURL.addUserToStandard + id + "/user/" + id2,
      null,
      { observe: "response" }
    );
  }

  deleteUserFromStandard(sID, uID) {
    return this.http.delete(
      this.apiURL.deleteUserFromStandard + sID + "/user/" + uID,
      { observe: "response" }
    );
  }

  changeStatusDeactivate(id) {
    // POST Сделать стандарт неактивным
    return this.http.post(
      this.apiURL.changeStatusDeactivate + id + "/deactivate",
      null,
      { observe: "response" }
    );
  }

  getChangeLogs(id) {
    // GET Получить список описаний изменений
    return this.http.get(this.apiURL.getChangeLogs + id + "/modify/notes", {
      observe: "response"
    });
  }

  renamePosGlobal(id: string, newName: string) {
    const a = {
      id: id,
      name: newName
    };
    return this.http.patch(this.apiURL.renamePosGlobal, a, {
      observe: "response"
    });
  }

  changeSalaryValue(id: string, value: string, des) {
    return this.http.post(this.apiURL.changeSalaryValue + '/?' + new HttpParams().set('userID', id).set('salary', value).set('description', des), {
      observe: "response"
    });
  }

  changeModalSettings(data) {
    return this.http.post(this.apiURL.changeModalSetting, data, {
      observe: "response"
    });
  }

  getModalSetting() {
    return this.http.get(this.apiURL.changeModalSetting, {
      observe: "response"
    });
  }

  getListWeekends(from, to) {
    return this.http.get(this.apiURL.getListWeekends  + '?' + new HttpParams().set('from', String(from)).set('to', String(to)), {
      observe: "response"
    });
  }

  addWeekends(localDate, type) {
    return this.http.post(this.apiURL.addWeekends  + '?' + new HttpParams().set('localDate', String(localDate)).set('isPublicHoliday',type ), {
      observe: "response"
    });
  }

  delWeekends(id) {
    return this.http.delete(this.apiURL.delWeekends + id, {
      observe: "response"
    });
  }

  getQuestionForTranslateByStandardID(urlID: string) {
    return this.http.get(
      this.apiURL.getQuestionForTranslateByStandardID +
        urlID +
        "/translate/questions",
      { observe: "response" }
    );
  }

  getStandardBaseLanguageByID(sID: string) {
    return this.http.get(this.apiURL.getStandardBaseLanguageByID + sID, {
      responseType: "text",
      observe: "response"
    });
    // {responseType: 'text'}
  }

  translateStandardMainInfoRequest(sID: string) {
    return this.http.get(this.apiURL.translatedMainInfo + sID, {
      observe: "response"
    });
  }

  doneStandardMainInfo(sID, standard) {
    return this.http.put(
      this.apiURL.doneStandardMainInfo + sID + "/translate",
      standard,
      { observe: "response" }
    );
  }

  doneTranslateQuestions(urlID, questionsList) {
    return this.http.put(
      this.apiURL.doneTranslateQuestions + urlID + "/translate/questions/",
      questionsList,
      { observe: "response" }
    );
  }

  getStandardTranslate(urlID: string) {
    return this.http.get(
      this.apiURL.getStandardTranslate + urlID + "/translate",
      { observe: "response" }
    );
  }

  getGroupsAndPositions() {
    return this.http.get(this.apiURL.getGroupsWithPos, { observe: "response" });
  }

  getGroupsAndPositionsHead() {
    return this.http.get(this.apiURL.getGroupsWithPosHead, { observe: "response" });
  }

  getAllPrefixes() {
    return this.http.get(this.apiURL.getAllPrefixesFromAPI, {
      observe: "response"
    });
  }

  getTypesByPrefixID(prefixID: string) {
    return this.http.get(this.apiURL.getTypesByPrefixID + prefixID, {
      observe: "response"
    });
  }

  //  Specializations

  getAllSpecs() {
    return this.http.get(this.apiURL.getAllSpecs, { observe: "response" });
  }

  getSpecById(specId) {
    return this.http.get(this.apiURL.getSpecById + specId, {
      observe: "response"
    });
  }

  getLearningSpecs(useriId) {
    return this.http.get(this.apiURL.getLearningSpecsById + useriId, {
      observe: "response"
    });
  }

  getLearningSpecsProfile(useriId) {
    return this.http.get(this.apiURL.getLearningSpecsProfile + useriId, {
      observe: "response"
    });
  }

  getLearningSpecsUser(useriId) {
    return this.http.get(this.apiURL.getLearningSpecsUser + useriId, {
      observe: "response"
    });
  }

  createSpecGroup(group) {
    return this.http.post(this.apiURL.createSpecGroup, group, {
      observe: "response"
    });
  }

  createSubSpecGroup(group, parentId) {
    return this.http.post(this.apiURL.createSubSpecGroup + parentId, group, {
      observe: "response"
    });
  }

  createSpec(group, parentId) {
    return this.http.post(this.apiURL.createSpec + parentId, group, {
      observe: "response"
    });
  }

  updateSpec(spec, id) {
    return this.http.patch(this.apiURL.updateSpec + '/' + id, spec,  {
      observe: "response"
    });
  }

  updateSpecGroup(group, id) {
    return this.http.patch(this.apiURL.updateSpecGroup + id, group, {
      observe: "response"
    });
  }

  uploadSpecFile(formData: FormData, lvl_id) {
    const headers = new HttpHeaders({});
    headers.append("Content-Type", "multipart/form-data");
    return this.http.post(this.apiURL.uploadSpecFile + lvl_id, formData, {
      headers: headers,
      observe: "response"
    });
  }

  setQualificationLevel(spec_id, user_id, lvl) {
    const params = new HttpParams()
      .set("specializationId", spec_id)
      .set("level", lvl);
    const headers = new HttpHeaders({
      "Content-Type": "application/x-www-form-urlencoded"
    });
    return this.http.post(this.apiURL.setQualificationLevel + user_id, null, {
      headers: headers,
      observe: "response",
      params: params
    });
  }

  checkUserAnswers(lvl_id, testingAnswersModel) {
    return this.http.put(
      this.apiURL.checkUserAnswers + lvl_id,
      testingAnswersModel,
      { observe: "response" }
    );
  }

  deleteTempDocxFileManually(fileLink, sID) {
    const params = new HttpParams().set("link", fileLink).set("sid", sID);

    return this.http.delete(this.apiURL.deleteTempDocxFileManually, {
      params: params,
      observe: "response"
    });
  }

  deleteTempDocxFileManuallyTemp(fileLink, sID) {
    const params = new HttpParams().set("link", fileLink).set("sid", sID);

    return this.http.delete(this.apiURL.deleteTempDocxFileManuallyTemp, {
      params: params,
      observe: "response"
    });
  }

  // UsersMolule
  getUsersList(params) {
    return this.http.post(this.apiURL.getUsers, params, {
      observe: "response"
    });
  }

  getUserInfo(id) {
    return this.http.get(this.apiURL.getUserInfo + id, {
      observe: "response"
    });
  }

  getGroups() {
    return this.http.get(this.apiURL.getGroups, {
      observe: "response"
    });
  }

  getPositions() {
    return this.http.get(this.apiURL.getPositions, {
      observe: "response"
    });
  }

  deleteTeamScheduleBuilding(id: string): Observable<void> {
    const url = `/backend/common/group/team_building/${id}`;
    return this.http.delete<void>(url);
  }

  teamScheduleBuilding(teamBuildingDto: any): Observable<any> {
    const url = `/backend/common/group/team_building`;
    return this.http.post<any>(url, teamBuildingDto);
  }

  updateTeamScheduleBuilding(id: string, scheduleId: string): Observable<any> {
    const url = `/backend/common/group/team_building/${id}/schedule/${scheduleId}`;
    return this.http.patch<any>(url, {});
  }

  updateTeamAddUser(id: string, userId: string): Observable<any> {
    const url = `/backend/common/group/team_building/${id}/add/user/${userId}`;
    return this.http.patch<any>(url, {});
  }

  updateTeamRemoveUser(id: string, userId: string): Observable<any> {
    const url = `/backend/common/group/team_building/${id}/remove/user/${userId}`;
    return this.http.patch<any>(url, {});
  }

  getAllTeamBuilding(groupId: string): Observable<any[]> {
    const url = `/backend/common/group/${groupId}/team_building`;
    return this.http.get<any[]>(url);
  }

  checkStandardNumberUniqueness(number: string) {
    const params = new HttpParams().set('number', number);
    return this.http.get(this.apiURL.checkStandardNumberUniqueness, {
      params: params,
      observe: 'response'
    });
  }

  updateStandardNumber(standardId: string, newNumber: string) {
    const params = new HttpParams()
      .set('standardId', standardId)
      .set('newNumber', newNumber);
    return this.http.patch(this.apiURL.updateStandardNumber, null, {
      params: params,
      observe: 'response'
    });
  }
}



// WEBPACK FOOTER //
// C:/work/new2/internal-frontend/src/app/services/admin.service.ts